import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/@babel/runtime/regenerator/index.js";
import React, { useEffect } from "react";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { useStore } from "@dp/state";
import { observer } from "mobx-react-lite";
import Head from "next/head";
import { PageLayout } from "../../util/constants";
var BeerMenuList = dynamic(function () {
  return import("@dp/xcomp").then(function (mod) {
    return mod.BeerMenuList;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@dp/xcomp")];
    }
  }
});
var BeerMenuPage = function BeerMenuPage() {
  var _store$menuList;
  var router = useRouter();
  var store = useStore();
  var brandCode = store === null || store === void 0 || (_store$menuList = store.menuList) === null || _store$menuList === void 0 || (_store$menuList = _store$menuList.appAttributes) === null || _store$menuList === void 0 || (_store$menuList = _store$menuList.concept) === null || _store$menuList === void 0 ? void 0 : _store$menuList.conceptCodeDesc;
  useEffect(function () {
    // Initialize both the component and ensure menu list is loaded
    var initPage = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return store === null || store === void 0 ? void 0 : store.initComponent("Menu");
            case 2:
              _context.next = 4;
              return store === null || store === void 0 ? void 0 : store.initComponent("BeerMenu");
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function initPage() {
        return _ref.apply(this, arguments);
      };
    }();
    initPage();
  }, []);
  var getPageTitle = function getPageTitle() {
    return "Beer Menu | ".concat(brandCode || "Restaurant");
  };
  return __jsx(React.Fragment, null, __jsx(Head, null, __jsx("title", null, getPageTitle()), __jsx("meta", {
    name: "viewport",
    content: "width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=no"
  }), __jsx("meta", {
    name: "description",
    content: "Explore our craft beer selection"
  })), __jsx(BeerMenuList, null));
};
BeerMenuPage.layout = PageLayout.DP_LAYOUT;
BeerMenuPage.layoutProps = {};
export default observer(BeerMenuPage);